module.exports = __webpack_public_path__ + "static/media/new-york-62.ee46324b.jpg";